import { includes, omit, reject } from 'lodash/fp';
import getOpeningHours from '@ahmdigital/logic/lib/utils/get-opening-hours';

import { FooterStaticProps, NavLink } from '../../types';
import constants from '../../../../ahm-constants';
import getStaticProps from '../get-static-props';

const getPetInsuranceProps = (): FooterStaticProps => {
  const cloneProps = omit('appCalloutIcons', getStaticProps());

  cloneProps.navLinks = reject(includes('Forms and guides'), cloneProps.navLinks) as NavLink[];

  const contactHours = (
    <>
      {getOpeningHours(constants.AHM_SERVICE_NAME.PET_INSURANCE)}
      <br />
      (except public holidays) <br />
    </>
  );

  return {
    ...cloneProps,
    contacts: [{ contactHours, contactNumber: constants.CONTACT.PHONE.PET_INSURANCE.PRETTY }],
  } as FooterStaticProps;
};

export default getPetInsuranceProps;
